
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { MainHeaderMenuService } from './main-header-menu.service';
import { LocalStoargeService } from './local-stoarge.service';
@Injectable({
  providedIn: 'root'
})
export class TokenExpireService {
  IsMobile: boolean = false;

  constructor(private EncrdecrService: EncrdecrService,
    private router: Router, public ShowHideHeaderMenu: MainHeaderMenuService,
  private localStorageService:LocalStoargeService) { }

  LogoutUser() {
    this.ShowHideHeaderMenu.hide();
    const CompanyName: string = environment.CompayName;
    var G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))); //Session_UserType
    const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
    sessionStorage.clear();
    // localStorage.clear();
    this.localStorageService.ClearLocalStorageWithoutCleverTapKeys();// Added by Tishya
    this.SetCompanyLogo();

    

    if (G_UserType == 1) {
      //window.open("https://aaa.indiainfoline.com/login","_self");
      this.router.navigateByUrl("/login-emp");
    }
    else if (G_UserType == 2) {
      //window.open("https://aaa.indiainfoline.com/login","_self");
      this.router.navigateByUrl("/login-cp")
    }
    else {
      let w = window.innerWidth
      if (w <= 767) {
        this.router.navigateByUrl("/login-incred")
      } else {
        this.router.navigateByUrl("/login-incred")
      }
    }
  }

  SetCompanyLogo() {
    const CompanyName: string = environment.CompayName;
    switch (CompanyName) {
      case 'JMF':
        sessionStorage.setItem('logo', '../../assets/images/InCred_capital_NewLogo.svg');
        sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("18"));
        sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', "18");
        sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        break;
    }
  }
}
